import { customDateSort, formatDate } from '../../../../helpers/HelperFunctions'
import FilterHeader from './FilterHeader'
import { COMPANY_STATUS_OBJ } from '../../../../helpers/Constants'

const renderColumnHeader = (props, label, field, filterOptions = null) => {
  if (!props?.onFilterClick) return <span>{label}</span>
  const selectedCount =
    Array.isArray(props?.activeFilters?.[field]) && props?.activeFilters[field].length > 0
      ? props.activeFilters[field].length
      : 0
  return (
    <FilterHeader
      label={label}
      onClick={(e) => {
        e.stopPropagation()
        props.onFilterClick(e, field)
      }}
      active={selectedCount > 0}
      options={filterOptions}
      selectedCount={selectedCount}
    />
  )
}

export const ServiceProviderColumn = (props) => {
  return [
    {
      field: 'key',
      headerName: 'S.No',
      align: 'center',
      headerAlign: 'center',
      flex: 0.175,
      sortable: false,
    },
    {
      field: 'name',
      headerName: 'Company Name',
      align: 'left',
      headerAlign: 'center',
      flex: 1,
      renderHeader: () => renderColumnHeader(props, 'Company Name', 'name'),
      renderCell: (params) => props.renderCompany(params),
      valueGetter: (params) => params.row.name,
    },
    {
      field: 'companyStatus',
      headerName: 'Status',
      align: 'center',
      headerAlign: 'center',
      flex: 0.3,
      width: '400px',
      valueGetter: (params) => {
        const statusObj = COMPANY_STATUS_OBJ.find(item => item.value === params.row.companyStatus)
        return statusObj ? statusObj.name : params.row.companyStatus
      },
      renderHeader: () => renderColumnHeader(
        props,
        'Status',
        'companyStatus',
        COMPANY_STATUS_OBJ.map((item) => ({
          label: item.name,
          value: item.value,
        }))
      ),
      renderCell: ({ row }) => {
        const statusObj = COMPANY_STATUS_OBJ.find(item => item.value === row.companyStatus)
        return props.renderCompanyStatus(row.companyStatus, statusObj?.name) // <-- pass statusId for color
      }
    },
    {
      field: 'resellerCount',
      headerName: 'Resellers',
      align: 'center',
      headerAlign: 'center',
      flex: 0.3,
      renderHeader: () => renderColumnHeader(props, 'Resellers', 'resellerCount'),
      renderCell: ({ value }) => (value == 0 ? '' : value),
      valueGetter: (params) => params.row.resellerCount,

    },
    {
      field: 'customerCount',
      headerName: 'Customers',
      align: 'center',
      headerAlign: 'center',
      flex: 0.3,
      renderHeader: () => renderColumnHeader(props, 'Customers', 'customerCount'),
      renderCell: ({ value }) => (value == 0 ? '' : value),
      valueGetter: (params) => params.row.customerCount,
    },
    {
      field: 'directCustomerCount',
      headerName: 'Direct Customers',
      align: 'center',
      headerAlign: 'center',
      flex: 0.3,
      renderHeader: () => renderColumnHeader(props, 'Direct Customers', 'directCustomerCount'),
      renderCell: ({ value }) => (value == 0 ? '' : value),
      valueGetter: (params) => params.row.directCustomerCount,
    },
    {
      field: 'createdDateTime',
      headerName: 'Registered Date',
      align: 'center',
      headerAlign: 'center',
      type: 'date',
      flex: 0.4,
      renderHeader: () => renderColumnHeader(props, 'Registered Date', 'createdDateTime'),
      sortComparator: (a, b) => customDateSort(a, b),
      valueGetter: (params) => formatDate(new Date(params.row.createdDateTime)),
    },
    {
      field: 'primaryContactEmail',
      headerName: 'Primary Contact',
      align: 'center',
      headerAlign: 'center',
      flex: 0.5,
      renderHeader: () => renderColumnHeader(props, 'Primary Contact', 'primaryContactEmail'),
      valueGetter: (params) => params.row.primaryContactEmail,
    },
  ]
}

export const ResellersColumn = (props) => {
  return [
    {
      field: 'key',
      headerName: 'S.No',
      align: 'center',
      headerAlign: 'center',
      flex: 0.2,
      sortable: false,
    },
    {
      field: 'name',
      headerName: 'Company Name',
      align: 'left',
      headerAlign: 'center',
      flex: 1,
      renderHeader: () =>
        renderColumnHeader(props, 'Company Name', 'name'),
      renderCell: (params) => props.renderCompany(params),
      valueGetter: (params) => params.row.name,
    },
    {
      field: 'companyStatus',
      headerName: 'Status',
      align: 'center',
      headerAlign: 'center',
      flex: 0.4,
      valueGetter: (params) => {
        const statusObj = COMPANY_STATUS_OBJ.find(
          (item) => item.value === params.row.companyStatus
        )
        return statusObj ? statusObj.name : params.row.companyStatus
      },

      renderHeader: () =>
        renderColumnHeader(
          props,
          'Status',
          'companyStatus',
          COMPANY_STATUS_OBJ.map((item) => ({
            label: item.name,
            value: item.value,
          }))
        ),
      renderCell: ({ row }) =>
        props.renderCompanyStatus(row.companyStatus),
    },
    {
      field: 'customerCount',
      headerName: 'Customers',
      align: 'center',
      headerAlign: 'center',
      flex: 0.3,
      renderHeader: () =>
        renderColumnHeader(props, 'Customers', 'customerCount'),
      renderCell: ({ value }) => (value === 0 ? '' : value),
      valueGetter: (params) => params.row.customerCount,
    },
    {
      field: 'createdDateTime',
      headerName: 'Registered Date',
      align: 'center',
      headerAlign: 'center',
      flex: 0.4,
      renderHeader: () =>
        renderColumnHeader(props, 'Registered Date', 'createdDateTime'),
      sortComparator: (a, b) => customDateSort(a, b),
      valueGetter: (params) =>
        formatDate(new Date(params.row.createdDateTime)),
    },
    {
      field: 'primaryContactEmail',
      headerName: 'Primary Contact',
      align: 'center',
      headerAlign: 'center',
      flex: 0.5,
      renderHeader: () =>
        renderColumnHeader(props, 'Primary Contact', 'primaryContactEmail'),
      valueGetter: (params) => params.row.primaryContactEmail,
    },
  ]
}

export const ReferralAgentColumn = (props) => {
  return [
    {
      field: 'key',
      headerName: 'S.No',
      align: 'center',
      headerAlign: 'center',
      flex: 0.2,
      sortable: false,
    },
    {
      field: 'name',
      headerName: 'Company Name',
      align: 'left',
      headerAlign: 'center',
      flex: 1,
      renderCell: (params) => props.renderCompany(params),
    },
    {
      field: 'companyStatus',
      headerName: 'Status',
      align: 'center',
      headerAlign: 'center',
      flex: 0.4,
      renderCell: ({ row, value }) => props.renderCompanyStatus(value),
      renderHeader: (params) => props.renderFilter(params),
    },
    {
      field: 'createdDateTime',
      headerName: 'Registered Date',
      align: 'center',
      headerAlign: 'center',
      flex: 0.4,
      renderHeader: (params) => props.renderFilter(params),
      sortComparator: (a, b) => customDateSort(a, b),
    },
    {
      field: 'primaryContactEmail',
      headerName: 'Primary Contact',
      align: 'center',
      headerAlign: 'center',
      flex: 0.5,
      renderHeader: (params) => props.renderFilter(params),
    },
  ]
}

export const CustomerColumn = (props) => {
  return [
    {
      field: 'key',
      headerName: 'S.No',
      align: 'center',
      headerAlign: 'center',
      flex: 0.2,
      sortable: false,
    },
    {
      field: 'name',
      headerName: 'Company Name',
      align: 'left',
      headerAlign: 'center',
      flex: 1,
      renderHeader: () =>
        renderColumnHeader(props, 'Company Name', 'name'),
      renderCell: (params) => props.renderCompany(params),
      valueGetter: (params) => params.row.name,
    },
    {
      field: 'companyStatus',
      headerName: 'Status',
      align: 'center',
      headerAlign: 'center',
      flex: 0.4,
      renderHeader: () =>
        renderColumnHeader(
          props,
          'Status',
          'companyStatus',
          COMPANY_STATUS_OBJ.map((s) => ({
            label: s.name,
            value: s.value,
          }))
        ),
      renderCell: ({ value }) => props.renderCompanyStatus(value),
      valueGetter: (params) => {
        console.log('params.row.companyStatus', params.row.companyStatus);

        const status = COMPANY_STATUS_OBJ.find(
          (s) => s.value === params.row.companyStatus
        )
        return status?.name || params.row.companyStatus
      },
    },
    {
      field: 'createdDateTime',
      headerName: 'Registered Date',
      align: 'center',
      headerAlign: 'center',
      flex: 0.4,
      renderHeader: () =>
        renderColumnHeader(props, 'Registered Date', 'createdDateTime'),
      valueGetter: (params) =>
        formatDate(new Date(params.row.createdDateTime)),
      sortComparator: (a, b) => customDateSort(a, b),
    },
    {
      field: 'primaryContactEmail',
      headerName: 'Primary Contact',
      align: 'center',
      headerAlign: 'center',
      flex: 0.4,
      renderHeader: () =>
        renderColumnHeader(props, 'Primary Contact', 'primaryContactEmail'),
      valueGetter: (params) => params.row.primaryContactEmail,
    },
  ]
}
